// extracted by mini-css-extract-plugin
export default {"container":"routes_container__7JRCZ","title":"routes_title__X7dvp"};